export const solutionsLinks = [
    { title: "Biotech", link: "/solutions/biotech-payment-solutions" },
    { title: "MedSpa", link: "/solutions/medspa-payment-solutions" },
    { title: "Aesthetic", link: "/solutions/aesthetics-clinics-merchant-accounts" },
    { title: "Private Equity", link: "/solutions/private-equity-payment-processing" },
    { title: "Freelancer", link: "/solutions/freelancer-payment-solutions" },
    { title: "Beauty Industry", link: "/solutions/beauty-industry-payment-processing" },
    { title: "Medical Supply", link: "/solutions/merchant-accounts-for-medical-supply-businesses" },
    { title: "Telemedicine", link: "/solutions/telemedicine-merchant-account" },
    { title: "Supplements & Nutraceuticals", link: "/solutions/supplements-nutraceutical-merchant-account" },
    { title: "Online Pharmacy", link: "/solutions/online-pharmacy-payment-processing" },
    { title: "Gaming", link: "/solutions/gaming-payment-solutions" },
    { title: "eCommerce", link: "/solutions/ecommerce-solutions" },
    { title: "Healthcare", link: "/solutions/solutions-for-healthcare" },
];